import {
  CancelButton,
  MainButton,
} from 'crono-fe-common/components/CronoButton';
import IconSWarning from 'crono-fe-common/icons/Icon-S-Warning';
import { colors } from 'crono-fe-common/theme';

export const RecordingDisclaimer = ({
  cancelRecording,
  confirmRecording,
}: {
  cancelRecording: () => void;
  confirmRecording: () => void;
}) => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="size-18 rounded-full grid place-content-center bg-red-200">
        <IconSWarning color={colors.inactive} size={36} />
      </div>

      <p className="text-gray-900 text-2xl font-bold mt-6">
        Please inform the other party before recording this call
      </p>
      <p className="text-gray-700 text-sm mt-2">
        Some countries and states require two-party consent in order to record.
      </p>

      <div className="flex gap-2 mt-10">
        <CancelButton onClick={cancelRecording}>Cancel</CancelButton>
        <MainButton onClick={confirmRecording}>Informed</MainButton>
      </div>
    </div>
  );
};
